module.exports = __webpack_public_path__ + "media/categories/1046-f8cd68bb.svg";